export default `
{
    copywriting_adjustments {
        first_customer_photo_hint
        subscriber_benefit_image_url
        referral {
            brife_rules
            complete_rules
        }
    }
}
`
